import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'
import { DocumentTypeTag } from '@/data/entities'

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

export function getDocumentTypeText(type: DocumentTypeTag) {
  switch (type) {
    case DocumentTypeTag.SOP:
      return 'SOP'
    case DocumentTypeTag.WI:
      return 'Work Instruction'
    case DocumentTypeTag.PRD:
      return 'PRD'
    case DocumentTypeTag.BDD:
      return 'BDD'
    case DocumentTypeTag.PDF:
      return 'PDF'
    case DocumentTypeTag.OTHER:
      return 'Other'
    default:
      return 'Unknown'
  }
}

export function getDocumentTypeColor(type: DocumentTypeTag) {
  switch (type) {
    case DocumentTypeTag.SOP:
      return 'bg-badge-purple'
    case DocumentTypeTag.WI:
      return 'bg-badge-orange'
    case DocumentTypeTag.PRD:
      return 'bg-badge-blue'
    case DocumentTypeTag.BDD:
      return 'bg-badge-pink'
    case DocumentTypeTag.PDF:
      return 'bg-gray-200 text-copy-primary'
    case DocumentTypeTag.OTHER:
      return 'bg-gray-200 text-copy-primary'
    default:
      return 'bg-gray-200 text-copy-primary'
  }
}

export const secondsToMinutes = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}:${remainingSeconds.toFixed(0).toString().padStart(2, '0')}`
}

export const minutesToSeconds = (timeString: string): number => {
  const parts = timeString.split(':')
  if (parts.length !== 2) return 0
  const minutes = parseInt(parts[0], 10) || 0
  const seconds = parseInt(parts[1], 10) || 0
  return minutes * 60 + seconds
}

export const calculateTimeDifference = (date: string) => {
  const createdDate = new Date(date)
  const now = new Date()
  const diffMs = now.getTime() - createdDate.getTime()
  const diffMinutes = Math.floor(diffMs / (1000 * 60))
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60))

  if (diffMinutes < 60) {
    return `${diffMinutes} ${diffMinutes === 1 ? 'min' : 'mins'} ago`
  } else if (diffHours < 24) {
    return `${diffHours} ${diffHours === 1 ? 'hr' : 'hrs'} ago`
  } else {
    return createdDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }
}

export const formatVideoDuration = (
  durationInSeconds: string | number,
): string => {
  const totalSeconds = Math.floor(
    typeof durationInSeconds === 'string'
      ? parseFloat(durationInSeconds)
      : durationInSeconds,
  )

  if (isNaN(totalSeconds)) {
    return '-'
  }

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  } else {
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }
}
